import { render, staticRenderFns } from "./JudgingWidget.vue?vue&type=template&id=7d6e6911&"
import script from "./JudgingWidget.vue?vue&type=script&lang=js&"
export * from "./JudgingWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports